"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import 'invariant';
import 'luxon';
import 'react-aria-components';
import clsx from 'clsx';
import '../../../../lib/propsContext/propsContext.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import '@mittwald/react-tunnel';
import '../../../../lib/slotContext/slotContext.mjs';
import '@react-aria/utils';
import 'remeda';
import 'dot-prop';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../Heading/Heading.mjs';
import '../../../Text/Text.mjs';
import 'react-aria';
import '../../../Button/Button.mjs';
import '../../../ContextMenu/ContextMenu.mjs';
import '../../../MenuItem/MenuItem.mjs';
import '../../../ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import '../../../ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';
import '../../../ColumnLayout/ColumnLayout.mjs';
import '../ListSummary/ListSummary.mjs';
import { useList } from '../../hooks/useList.mjs';
import '../../List.mjs';
import { TableLoadingView } from './components/TableLoadingView.mjs';
import styles from './Table.module.css.mjs';
import ListEmptyViewView from '../../../../views/ListEmptyViewView.mjs';
import TableView from '../../../../views/TableView.mjs';
import TableHeaderView from '../../../../views/TableHeaderView.mjs';
import TableBodyView from '../../../../views/TableBodyView.mjs';
import TableRowView from '../../../../views/TableRowView.mjs';
import TableCellView from '../../../../views/TableCellView.mjs';
import TableColumnView from '../../../../views/TableColumnView.mjs';

const Table = () => {
  const list = useList();
  const table = list.table;
  const listIsEmpty = list.useIsEmpty();
  const isLoading = list.loader.useIsLoading();
  const isInitiallyLoading = list.loader.useIsInitiallyLoading();
  if (!table) {
    return null;
  }
  if (isInitiallyLoading) {
    return /* @__PURE__ */ jsx(TableLoadingView, { ...table.componentProps });
  }
  if (listIsEmpty) {
    return /* @__PURE__ */ jsx(ListEmptyViewView, {});
  }
  const rowAction = table.list.onAction;
  const tableClassName = clsx(
    styles.table,
    isLoading && styles.isLoading,
    table.componentProps.className
  );
  return /* @__PURE__ */ jsxs(
    TableView,
    {
      ...list.componentProps,
      ...table.componentProps,
      className: tableClassName,
      children: [
        /* @__PURE__ */ jsx(TableHeaderView, { ...table.header.componentProps, children: table.header.columns.map((col, i) => /* @__PURE__ */ jsx(TableColumnView, { ...col.componentProps }, i)) }),
        /* @__PURE__ */ jsx(TableBodyView, { ...table.body.componentProps, children: list.items.entries.map((item) => /* @__PURE__ */ jsx(
          TableRowView,
          {
            className: (props) => clsx(
              styles.row,
              rowAction && styles.hasAction,
              table.body.row.componentProps.className,
              props.isSelected && styles.isSelected
            ),
            id: item.id,
            onAction: rowAction ? () => rowAction(item.data) : void 0,
            ...table.body.row.componentProps,
            children: table.body.row?.cells.map((cell, i) => /* @__PURE__ */ jsx(TableCellView, { ...cell.componentProps, children: cell.renderFn ? cell.renderFn(item.data, list) : void 0 }, i))
          },
          item.id
        )) })
      ]
    }
  );
};

export { Table };
//# sourceMappingURL=Table.mjs.map
